import { render, staticRenderFns } from "./buyResult.vue?vue&type=template&id=4d4be074&"
import script from "./buyResult.vue?vue&type=script&lang=js&"
export * from "./buyResult.vue?vue&type=script&lang=js&"
import style0 from "./buyResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports